import "@fontsource-variable/inter";
import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { IntlProvider } from "use-intl";

import { ThemedToaster } from "@/components/themed-toaster";
import { ThemeProvider } from "@/hooks/use-theme";
import { loadMessages } from "@/i18n/messages";
import { router } from "@/router";

const { locale, messages } = await loadMessages();
document.documentElement.lang = locale;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <IntlProvider locale={locale} messages={messages}>
      <ThemeProvider>
        <RouterProvider router={router} />
        <ThemedToaster />
      </ThemeProvider>
    </IntlProvider>
  </StrictMode>,
);
